import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { StyledEppsParentView } from '../global/styles/styled';
import ScenarioHeader from './components/ScenarioHeader';
import type { ChannelOption } from './components/ScenarioHeader/constants';
import type { ScenarioContextType } from './hooks/useScenarioContext';

export const ScenarioWrapper: React.FC = () => {
  const [selectedChannel, setSelectedChannel] = useState<ChannelOption | null>(
    null,
  );
  const [isSingleChannel, setIsSingleChannel] = useState(false);

  const scenarioContext: ScenarioContextType = {
    selectedChannel,
    setSelectedChannel,
    isSingleChannel,
    setIsSingleChannel,
  };

  return (
    <StyledEppsParentView>
      <ScenarioHeader isSingleChannel={isSingleChannel} />
      <Outlet context={scenarioContext} />
    </StyledEppsParentView>
  );
};

export default ScenarioWrapper;
